import {ReactElement} from "react";
import {EditProps} from "react-admin";
import {AsideLog} from "./AsideLog";
import {CustomEdit} from "./CustomEdit";

export const DefaultEdit = (props: EditProps & { children: ReactElement }) => {
  return (
    <CustomEdit
      component="div"
      {...props}
      aside={
        <AsideLog />
      }
      mutationMode={"pessimistic"}
    />
  );
};
